export default {"src":"/_next/static/image/public/images/ic_notified_me.afcc527adfa77b19a7efa088ac6dcabf.svg","height":32,"width":107};